import { ListingDetailsModalTabId } from '@/models';

import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useListingImageGalleryStore = defineStore('ListingImageGallery', () => {
  const isModalOpen = ref(false);
  const isModalLoaded = ref(false);
  const contactFormOpenRequest = ref(false);
  const selectedModalTabId = ref<ListingDetailsModalTabId>(
    ListingDetailsModalTabId.MODAL_TAB_ID_IMAGEGALLERY,
  );
  const activeFloorPlanSlideIndex = ref(0);

  function openModal() {
    isModalOpen.value = true;
    isModalLoaded.value = true;
  }

  function closeModal() {
    isModalOpen.value = false;
  }

  function setSelectedModalTabId(tabId: ListingDetailsModalTabId) {
    selectedModalTabId.value = tabId;
  }

  function setActiveFloorPlanSlideIndex(index: number) {
    activeFloorPlanSlideIndex.value = index;
  }

  function requestOpenContactForm() {
    contactFormOpenRequest.value = true;
  }

  function consumeContactFormOpenRequest() {
    contactFormOpenRequest.value = false;
  }

  return {
    isModalOpen,
    isModalLoaded,
    contactFormOpenRequest,
    selectedModalTabId,
    activeFloorPlanSlideIndex,
    openModal,
    closeModal,
    setSelectedModalTabId,
    setActiveFloorPlanSlideIndex,
    requestOpenContactForm,
    consumeContactFormOpenRequest,
  };
});
